import { useRecoilCallback } from "recoil";
import { EDITABLE_PATHS } from "../utils/constants/common/urlPaths";
import { TComponentType } from "../utils/types/common/components.types";
import { TUrlPath } from "../utils/types/elements/XText.types";
import {
  COMMON_ELEMENT_INDEXES,
  isCommon,
  USE_X_COMMON,
  USE_X_COMMON_CHILDREN_SELECTOR,
} from "./useXCommon";
import { USE_X_ELEMENT, USE_X_ELEMENT_SELECTOR } from "./useXElement";
import { useXPageUpdater, USE_X_PAGE } from "./useXPage";
import { USE_X_PATH } from "./useXPath";

export const useSaveData = () => {
  const setXPage = useXPageUpdater();

  return useRecoilCallback(
    ({ snapshot }) =>
      async () => {
        try {
          const pagesAndCommons: any = {};

          const currentPath = await snapshot.getPromise(USE_X_PATH);

          // GETTING PAGES USING PATH
          await Promise.all(
            EDITABLE_PATHS.map(async (path) => {
              let currentPage = await snapshot.getPromise(USE_X_PAGE(path));

              if (currentPath === path) {
                currentPage = await Promise.all(
                  currentPage.map(async (el) => {
                    if (!el.config) return el;

                    const element = await snapshot.getPromise(
                      USE_X_ELEMENT(el.config.index)
                    );

                    // if (path !== "/") {
                    //   console.log(
                    //     "PATH =>",
                    //     path,
                    //     "EL PAGE =>",
                    //     el,
                    //     "EL UPDATED =>",
                    //     element
                    //   );
                    // }

                    if (!element) return el;

                    const data: any = {
                      name: element.name,
                      props: element.value,
                      config: { index: element.index },
                      dataFetching: element.dataFetching,
                    };

                    if (element.childOf) data.config.childOf = element.childOf;

                    return data;
                  })
                );
              }

              pagesAndCommons[path] = currentPage;
            })
          );

          // UPDATING CURRENT PAGE ELEMENTS TO THE LATEST DATA
          Object.keys(pagesAndCommons).forEach((path: TUrlPath) => {
            setXPage({ path, elements: pagesAndCommons[path] });
          });

          // GETTING COMMON ELEMENTS TO UPDATE HEADER / FOOTER / ARTICLE / ETC...
          const commons: TComponentType[] = [];

          await Promise.all(
            COMMON_ELEMENT_INDEXES.map(async (index) => {
              const element = await snapshot.getPromise(USE_X_COMMON(index));

              // ONLY UPDATE IF WE FINA DATA
              if (element) {
                const data: any = {
                  name: element.name,
                  props: element.value,
                  config: { index: element.index },
                };

                if (element.dataFetching)
                  data.dataFetching = element.dataFetching;

                if (element.childOf) data.config.childOf = element.childOf;

                pagesAndCommons[index.toLocaleLowerCase()] = isCommon(
                  index,
                  true
                )
                  ? data.props
                  : data;

                // GET CHILDREN
                const children = await snapshot.getPromise(
                  USE_X_COMMON_CHILDREN_SELECTOR(index)
                );

                await Promise.all(
                  children.map(async (el) => {
                    if (!el.config) return;

                    const child = await snapshot.getPromise(
                      USE_X_ELEMENT_SELECTOR(el.config.index)
                    );

                    if (!child) return;

                    const childData: any = {
                      name: child.name,
                      props: child.value,
                      config: { index: child.index },
                    };

                    if (child.dataFetching) {
                      childData.dataFetching = child.dataFetching;
                    }

                    if (child.childOf) {
                      childData.config.childOf = child.childOf;
                    }

                    commons.push(childData);
                  })
                );
              }

              return element;
            })
          );

          pagesAndCommons.commons = commons;

          // SAVE THE LATEST DATA
          // await onSave();

          console.log("SAVED DATA =>", pagesAndCommons);

          return pagesAndCommons;
        } catch (error) {
          console.error(error);
        }

        return null;
      },
    []
  );
};
